<template>
  <div class="users" v-if="options && syouninGroupDetail">
    <div class="maininfo">

      <div>
        <p>変更する所属ユーザーを選択して下さい</p>
      </div>

      <div style="display:flex">
        <div class="container">
         <section>
          <div class="item-container">
            <label>
              <p class="optional">所属するユーザーリスト</p>
            </label>
          </div>
          <div class="item-container delete-table">
            <div class="selectedFacility">
              <scroll-table max-height="calc(70vh - 190px)">
                <table>
                  <thead>
                    <tr>
                      <th>ユーザー名</th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in syouninGroupDetail.group_users" :key="row.user_id">
                      <td class="office">{{ row.staff_name }}</td>
                      <td class="delete">
                        <i class="fa-solid fa-delete-left" @click="removeSelectUser(row)"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </scroll-table>
            </div>
          </div>
         </section>
        </div>

        <div class="btn-container">
          <button type="button" class="btn success" @click="pushUserList" :disabled="selectItemCount === 0">
            選択した{{ selectItemCount }}件のユーザーを追加する
          </button>
          <div style="text-align:center;">
            <i class="fa-solid fa-arrow-left"></i>
          </div>
        </div>

        <div>
          <div class="facility-search">
            <div class="container">
             <section>
              <div class="item-container">
                <label>
                  <!-- <b class="optional">検索条件：仮：検討中。現在は全ユーザーを取得</b> -->
                  <!-- <input-text v-model="searchCondition" type="text"></input-text> -->
                </label>
              </div>

              <div class="filter">
                  <label>検索した結果をユーザー名でフィルターします：</label>
                  <input v-model="filterCondition" type="text">
              </div>

              <div class="item-container">
                <label>
                  <p class="required">ユーザーを検索します。</p>
                </label>
              </div>

              <div class="btn-container">
                <button type="button" class="btn primary" @click="search"><i
                    class="fa-solid fa-magnifying-glass"></i>検索</button>
              </div>
            

            <div class="search-result" v-if="selectableGroupUserList.length">
              <scroll-table max-height="calc(70vh - 340px)">
                <table>
                  <thead>
                    <tr>
                      <th>&nbsp;</th>
                      <th>社員番号</th>
                      <th>ユーザー名</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in filteredUsers" :key="index">
                      <td class="delete"><input-checkbox :options="OptionConst.NO_LABEL" v-model="row.is_select"
                          :disabled="row.active"></input-checkbox></td>
                      <td>{{ row.staff_code }}</td>
                      <td>{{ row.staff_name }}</td>
                    </tr>
                  </tbody>
                </table>
              </scroll-table>
            </div>
             </section>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue'
import OptionConst from '@/const/Option';
import { SyouninGroupDetail, SyouninGroupOptions, SyouninGroupUser } from '@/types/SyouninGroup';
import { useSyouninGroup } from '@/composable/master/syounin_group/syounin_group';

export default defineComponent({
  props: {
    syouninGroupDetail: {
      type: Object as () => SyouninGroupDetail | null,
      default: null
    },
    options: {
      type: Object as () => SyouninGroupOptions | null,
      default: null
    }
  },
  emits: {
    reload() {
      return true
    }
  },
  setup(props, context) {
    const { selectableGroupUserList, getSelectableSyouninGroupUserList, deleteGroupUser,isAdding, addGroupUser } = useSyouninGroup()
    
    // ユーザーを検索します
    const search = async () => {
      if (!props.syouninGroupDetail) {
        return
      }
      await getSelectableSyouninGroupUserList(props.syouninGroupDetail.syounin_type);
    };

    // フィルタ変数
    const filter = ref('');

    let filterCondition = ref('');

    const filteredUsers = computed(() => {
      if (filterCondition.value) {
        return selectableGroupUserList.value.filter(user => user.staff_name.match(filterCondition.value))
      } else {
        return selectableGroupUserList.value
      }
    })

    // 承認者リストへ追加します
    const pushUserList = async () => {
      if (!props.syouninGroupDetail) {
        return
      }
      let mstSyouninGroupId = props.syouninGroupDetail.mst_syounin_group_id;
      let selectedUserList = selectableGroupUserList.value.filter((v: any) => v.is_select);

      await addGroupUser(mstSyouninGroupId, selectedUserList)
      context.emit('reload')
    };


    // 選択したユーザーの行数を返す(検索結果)
    const selectItemCount = computed(() => {
      const selectItems = selectableGroupUserList.value.filter((v: any) => v.is_select);
      return selectItems.length;
    });

    // リストからユーザーを削除します
    const removeSelectUser = async (user: SyouninGroupUser) => {
      if (!props.syouninGroupDetail) {
        return
      }
      await deleteGroupUser(user)
      context.emit('reload')
    };

    return {
      OptionConst,
      filter,

      // 検索
      search,
      selectableGroupUserList,
      // 追加
      pushUserList,
      selectItemCount,
      isAdding,
      addGroupUser,
      // 削除
      removeSelectUser,
      deleteGroupUser,
      filterCondition,
      filteredUsers,
    }
  },
})
</script>

<style lang="scss" scoped>
@import "@scss/components/syounin_group_edit.scss";
</style>
